// @flow

import * as React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';

import { featureIsEnabled } from '@ta/common.features';
import { Track } from '@ta/common.tracking';
import AdTarget from '@ta/cpm.ad-target';
import { SaveFromGeoRightRail } from '@ta/site-educators.saves';
import { ExploreDestination, ExploreDestinationData } from '@ta/social.explore-destination';
import FeaturedDestinations from '@ta/social.featured-destinations';
import {
  SponsoredDmoItemsQuery,
  SponsoredDmoModule,
} from '@ta/social.dmo-sponsored-right-rail-module';

type ExternalProps = {|
  minimumFilters?: number,
|};

type Props = {|
  ...ExternalProps,
  geoId: number,
  isNearby: boolean,
|};

const RightHandRail = ({ minimumFilters = 1, geoId, isNearby }: Props) => {
  const siteEducatorsSavesEnabled = featureIsEnabled('cx_site_educators_saves');

  // Unscoped Right Rail
  if (geoId === 1) {
    return <FeaturedDestinations />;
  }

  // Nearby Right Rail
  else if (isNearby) {
    return siteEducatorsSavesEnabled ? (
      <SaveFromGeoRightRail geoId={geoId} />
    ) : (
      <FeaturedDestinations />
    );
  }

  // Scoped Right Rail
  else if (geoId !== 1) {
    return (
      <>
        <SponsoredDmoModule />
        <ExploreDestinationData>
          {scopedGeoData =>
            scopedGeoData?.filterList?.length >= minimumFilters ? (
              <Track
                mount={{
                  module: 'Scoped_right_rail',
                  action: 'Explore_Destination_Impression',
                  context: `${geoId}`,
                  once: true,
                }}
              >
                {siteEducatorsSavesEnabled ? (
                  <SaveFromGeoRightRail geoId={geoId} />
                ) : (
                  <ExploreDestination scopedGeoData={scopedGeoData} locationId={geoId} />
                )}
              </Track>
            ) : (
              <Query query={SponsoredDmoItemsQuery} variables={{ locationId: geoId }}>
                {({ data, loading }) => {
                  const sponsorshipData =
                    data && data.locations && data.locations[0] && data.locations[0].dmoItems;
                  if (!loading && !sponsorshipData) {
                    return siteEducatorsSavesEnabled ? (
                      <SaveFromGeoRightRail geoId={geoId} />
                    ) : (
                      <FeaturedDestinations />
                    );
                  }

                  return siteEducatorsSavesEnabled ? <SaveFromGeoRightRail geoId={geoId} /> : null;
                }}
              </Query>
            )
          }
        </ExploreDestinationData>

        {/* This ad is suppressed for DMO-sponsored geos */}
        <Query query={SponsoredDmoItemsQuery} variables={{ locationId: geoId }}>
          {({ data, loading }) => {
            const sponsorshipData =
              data && data.locations && data.locations[0] && data.locations[0].dmoItems;
            if (!loading && !sponsorshipData) {
              return <AdTarget size="300x250" position="rail1" />;
            }

            return null;
          }}
        </Query>
      </>
    );
  }

  return null;
};

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  geoId: state?.page?.geoId,
  isNearby: state?.route?.isNearby,
}))(RightHandRail);
